import { post } from '../helpers'

export default {
  unbindAlipay() {
    const path = `api/accounts/unbind_alipay`
    return post(path)
  }
}
